import { render, staticRenderFns } from "./importform-new-2.vue?vue&type=template&id=6ef29632&scoped=true&"
import script from "./importform-new-2.vue?vue&type=script&lang=js&"
export * from "./importform-new-2.vue?vue&type=script&lang=js&"
import style0 from "./importform-new-2.vue?vue&type=style&index=0&id=6ef29632&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef29632",
  null
  
)

export default component.exports